import { Checkbox } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'Checkbox.Group',
    component: Checkbox,
});
